export default "__VITE_ASSET__Ccc5fCXU__"